// @ts-nocheck
import React from "react";
import { FormikSelect } from "src/components/Forms/Select";
import { fanbytes_search_criteria } from "src/constants/account";
import { Box } from "src/components/Core/Box";

interface Props {}

const SearchType: React.FC<Props> = () => {
  return (
    <Box mb={20} id="searchType">
      <FormikSelect
        name="searchType"
        data={fanbytes_search_criteria}
        local
        borderRadius={3}
        borderColor="grey5"
        size="middle"
      />
    </Box>
  );
};

export default SearchType;
